import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SiteHeader from "../components/gridvest/SiteHeader";
import Footer from "../components/gridvest/Footer";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#07111F] text-[#F8FAFC]" data-testid="privacy-page">
      <SiteHeader />

      <main className="relative">
        <div className="gv-grid-bg absolute inset-x-0 top-0 h-[320px]" aria-hidden />

        <section className="relative mx-auto max-w-3xl px-6 pb-20 pt-16 lg:px-8 lg:pt-24">
          <Link
            to="/"
            className="mb-10 inline-flex items-center gap-2 font-body text-sm text-[#94A3B8] transition-colors hover:text-[#F8FAFC]"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to home
          </Link>

          <p className="mb-5 font-display text-[12px] font-extrabold uppercase tracking-[0.18em] text-[#38BDF8]">
            Privacy Policy
          </p>
          <h1 className="font-display text-4xl font-extrabold leading-[1] tracking-[-0.04em] text-[#F8FAFC] sm:text-5xl">
            Privacy Policy
          </h1>
          <p className="mt-4 font-body text-sm text-[#94A3B8]">
            Effective: {new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
          </p>

          <div className="mt-12 space-y-9 font-body text-[15px] leading-[1.8] text-[#CBD5E1]">
            <Sec title="1. Overview">
              InfraYield ("we," "us," "our") respects your privacy. This Privacy Policy
              describes how we collect, use, and disclose information when you visit
              our website and interact with our services during our early-access phase.
            </Sec>
            <Sec title="2. Information We Collect">
              We collect information you provide directly to us, including your name,
              email address, company, role, asset details, and any message content you
              submit through our waitlist, owner-intake, or contact forms. We also
              collect limited technical information such as device, browser, referring
              URL, and pages viewed.
            </Sec>
            <Sec title="3. How We Use Information">
              We use information to operate the website, respond to inquiries, evaluate
              partnership and ownership opportunities, send transactional and product
              communications, and improve InfraYield. We do not sell your personal
              information.
            </Sec>
            <Sec title="4. Sharing">
              We share information only with service providers who help us operate
              InfraYield (hosting, email delivery, analytics), under contractual
              confidentiality obligations, or where required by law.
            </Sec>
            <Sec title="5. Data Retention">
              We retain personal information for as long as necessary to fulfill the
              purposes outlined in this policy, comply with legal obligations, resolve
              disputes, and enforce our agreements.
            </Sec>
            <Sec title="6. Your Choices">
              You may request access, correction, or deletion of your personal
              information by emailing{" "}
              <a href="mailto:privacy@infrayield.co" className="text-[#38BDF8] underline underline-offset-2 hover:text-[#F8FAFC]">privacy@infrayield.co</a>.
              You may unsubscribe from marketing emails at any time using the link in
              any such message.
            </Sec>
            <Sec title="7. Security">
              We use commercially reasonable administrative, technical, and physical
              safeguards to protect personal information, though no system can be
              guaranteed to be entirely secure.
            </Sec>
            <Sec title="8. Children">
              InfraYield is not directed to children under 13, and we do not knowingly
              collect personal information from children.
            </Sec>
            <Sec title="9. Changes">
              We may update this Privacy Policy from time to time. Material changes
              will be posted on this page with an updated effective date.
            </Sec>
            <Sec title="10. Contact">
              Questions about this policy? Contact{" "}
              <a href="mailto:privacy@infrayield.co" className="text-[#38BDF8] underline underline-offset-2 hover:text-[#F8FAFC]">privacy@infrayield.co</a>.
            </Sec>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

function Sec({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-lg font-semibold uppercase tracking-[0.06em] text-[#F8FAFC]">
        {title}
      </h2>
      <div className="mt-3">{children}</div>
    </section>
  );
}
